import { AsyncPipe, NgClass } from '@angular/common'
import { ChangeDetectionStrategy, Component, inject } from '@angular/core'

import { TranslatePipe } from '@ngx-translate/core'

import { DeviceService } from '@ti/core/common/services'
import { LanguageService } from '@ti/core/ui-kit/i18n'
import { DataGridComponent } from '@ti/core/ui-kit/layout/components/data-grid'

import { AuditLogsListModel } from '../../services/audit-logs-list.model'

@Component({
  selector: 'app-audit-logs-grid',
  templateUrl: 'audit-logs-grid.component.html',
  styleUrl: 'audit-logs-grid.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AsyncPipe, DataGridComponent, NgClass, TranslatePipe],
})
export class AuditLogsGridComponent {
  protected readonly model = inject(AuditLogsListModel)
  protected readonly languageService = inject(LanguageService)
  protected readonly deviceService = inject(DeviceService)
}
